import { IVec3, Vec3 } from "@base/math/Vec3";
import { ConfiguratorItemData, expect3d, ProductData3d } from "@biz/definitions/IVariantData3d";
import { CloneHelper } from "@biz/items/CloneHelper";
import { CalcModelProduct3dLogic } from "@biz/items/lounge/CalcModelProduct3dLogic";
import { IBizItemInterface } from "@biz/items/product/IBizItemInterface";
import { ICalcContext, ICalculatedProductResult } from "@biz/projectCalculation/ProjectDefinitions";

export function createModelProductBizImpl(): IBizItemInterface {
  const itemType = "modelProduct";
  return {
    calc3d(product: ProductData3d, slc: ICalcContext): ICalculatedProductResult {
      expect3d(product, itemType)
      return CalcModelProduct3dLogic.calc3d(product, slc)
    },
    calcCloneOffset(item: ConfiguratorItemData): IVec3 {
      expect3d(item, itemType);
      return Vec3.from(1, 0, 1)
    },
    cloneItem(item: ConfiguratorItemData, options?: { newId?: string; parentId?: string; cloneOffset?: IVec3 }): { item: ConfiguratorItemData, children?: ConfiguratorItemData[] } | undefined {
      expect3d(item, itemType);
      const cloneOffset = options?.cloneOffset ?? this.calcCloneOffset(item);
      return CloneHelper.clone(item, { transform: CloneHelper.moveTransform(item.transform, cloneOffset) }, options)
    }
  }
}